export default __webpack_public_path__ + "static/media/hero.4daf351f.png";